import * as React from "react";

const SliderTabRight: React.FC = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 14C28 18.1463 28 25.7315 28 28C25.6667 28 17.5857 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C17.5857 0 25.6667 0 28 0C28 2.2685 28 9.85367 28 14Z" fill="white" fillOpacity="0.85"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M16.4688 14L10.5048 19.9907C9.97408 20.5238 10.0376 21.4032 10.6394 21.8546C11.133 22.2247 11.8238 22.175 12.2593 21.7379L19.9688 14L12.2593 6.26207C11.8238 5.825 11.133 5.77526 10.6394 6.14545C10.0376 6.59683 9.97408 7.47621 10.5048 8.00935L16.4688 14Z" fill="#999999"/>
        </svg>
    );
};

export default React.memo(SliderTabRight);
